import { render, staticRenderFns } from "./edit1.vue?vue&type=template&id=3c401d5b&scoped=true&"
import script from "./edit1.vue?vue&type=script&lang=js&"
export * from "./edit1.vue?vue&type=script&lang=js&"
import style0 from "./edit1.vue?vue&type=style&index=0&id=3c401d5b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c401d5b",
  null
  
)

export default component.exports